import { render } from "./AddressInformation.vue?vue&type=template&id=27bef50b&scoped=true"
import script from "./AddressInformation.vue?vue&type=script&lang=js"
export * from "./AddressInformation.vue?vue&type=script&lang=js"

import "./AddressInformation.vue?vue&type=style&index=0&id=27bef50b&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27bef50b"]])

export default __exports__